/* MkaeSense site layer: compare tray, command search, motion. No dependencies. */
(function () {
  'use strict';
  var SELF = document.currentScript;
  if (window.__mkSite) return;
  window.__mkSite = 1;

  var D = document;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function h(tag, cls, html) { var e = D.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { return '$' + (cents / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function store(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null');
      sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* =====================================================================
     1. COMPARE TRAY
     ===================================================================== */
  var MAX = 3;
  var sel = store('mkCmp') || [];
  var bar, dlg, toastTimer;

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function metaOf(card, hd) {
    var img = card.querySelector('img');
    var t = '';
    var p = card.querySelector('a.contents p, .product-card__title, [class*="title"]');
    if (p) t = p.textContent.trim();
    if (!t && img) t = img.getAttribute('alt') || '';
    var src = img ? (img.currentSrc || img.src || '') : '';
    return { h: hd, t: t || hd.replace(/-/g, ' '), i: src };
  }
  function idx(hd) { for (var i = 0; i < sel.length; i++) if (sel[i].h === hd) return i; return -1; }

  function toast(msg) {
    var t = $('#mk-toast');
    if (!t) { t = h('div', 'mk-toast'); t.id = 'mk-toast'; t.setAttribute('role', 'status'); D.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  function toggle(hd, card) {
    var i = idx(hd);
    if (i > -1) sel.splice(i, 1);
    else {
      if (sel.length >= MAX) { toast('You can compare up to ' + MAX + ' products. Remove one first.'); return; }
      sel.push(metaOf(card, hd));
    }
    store('mkCmp', sel); paint();
  }

  function decorate() {
    $$('product-card').forEach(function (c) {
      if (c.__mkc) return;
      var hd = handleOf(c);
      if (!hd) return;
      var g = c.querySelector('.card-gallery') || c;
      c.__mkc = 1;
      var b = h('button', 'mk-cmp-btn', '<span class="mk-cmp-tick" aria-hidden="true"></span><span class="mk-cmp-lab">Compare</span>');
      b.type = 'button'; b.dataset.h = hd;
      b.setAttribute('aria-label', 'Compare ' + metaOf(c, hd).t);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(hd, c); });
      g.appendChild(b);
    });
    paint();
  }

  function paint() {
    $$('.mk-cmp-btn').forEach(function (b) { b.setAttribute('aria-pressed', idx(b.dataset.h) > -1 ? 'true' : 'false'); });
    if (!bar) {
      bar = h('div', 'mk-cmp-bar');
      bar.id = 'mk-cmp'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Compare products');
      D.body.appendChild(bar);
      bar.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-rm]');
        if (rm) { var i = idx(rm.getAttribute('data-rm')); if (i > -1) { sel.splice(i, 1); store('mkCmp', sel); paint(); } return; }
        if (e.target.closest('[data-clear]')) { sel = []; store('mkCmp', sel); paint(); return; }
        if (e.target.closest('[data-go]') && sel.length > 1) openCompare();
      });
    }
    var tpl = (($('main') || {}).getAttribute && $('main').getAttribute('data-template')) || '';
    if (!sel.length || !/index|collection|search/.test(tpl)) { bar.classList.remove('is-on'); return; }
    var chips = sel.map(function (s) {
      return '<span class="mk-cmp-chip">' + (s.i ? '<img src="' + esc(s.i) + '" alt="">' : '') +
        '<button type="button" data-rm="' + esc(s.h) + '" aria-label="Remove ' + esc(s.t) + '">×</button></span>';
    }).join('');
    bar.innerHTML = '<div class="mk-cmp-chips">' + chips + '</div>' +
      '<div class="mk-cmp-act"><button type="button" class="mk-cmp-clear" data-clear>Clear</button>' +
      '<button type="button" class="mk-cmp-go" data-go' + (sel.length < 2 ? ' disabled' : '') + '>' +
      (sel.length < 2 ? 'Pick one more' : 'Compare ' + sel.length) + '</button></div>';
    bar.classList.add('is-on');
  }

  var HIDE_TAG = /^(sg-|shop-all|hidden|cj|new|sale|featured|best)/i;
  function niceTags(tags) {
    return (tags || []).filter(function (t) { return !HIDE_TAG.test(t) && !/-(cameras|lights|power)$/i.test(t) && t.length < 22; })
      .slice(0, 6).map(function (t) { return t.replace(/-/g, ' '); });
  }
  function bullets(html) {
    var d = h('div', '', html || '');
    return $$('li', d).map(function (l) { return l.textContent.trim(); }).filter(Boolean).slice(0, 6);
  }

  function openCompare() {
    if (!dlg) {
      dlg = h('dialog', 'mk-dlg');
      dlg.setAttribute('aria-label', 'Product comparison');
      D.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
    }
    dlg.innerHTML = '<div class="mk-dlg-head"><strong>Compare</strong><button type="button" data-close aria-label="Close">×</button></div><div class="mk-cmp-wrap"><p class="mk-dlg-load">Loading…</p></div>';
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    Promise.all(sel.map(function (s) {
      return fetch('/products/' + s.h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      if (ps.length < 2) { $('.mk-cmp-wrap', dlg).innerHTML = '<p class="mk-dlg-load">Could not load those products. Please try again.</p>'; return; }
      var low = Math.min.apply(null, ps.map(function (p) { return p.price; }));
      function row(label, fn) {
        return '<tr><th scope="row">' + label + '</th>' + ps.map(function (p) { return '<td>' + fn(p) + '</td>'; }).join('') + '</tr>';
      }
      var html = '<table class="mk-cmp-tbl"><thead><tr><th></th>' + ps.map(function (p) {
        var im = p.featured_image ? '<img src="' + esc(p.featured_image.replace(/^\/\//, 'https://')) + '" alt="" loading="lazy">' : '';
        return '<th scope="col" class="mk-cmp-prod">' + im + '<a href="' + esc(p.url) + '">' + esc(p.title) + '</a></th>';
      }).join('') + '</tr></thead><tbody>' +
        row('Price', function (p) { return '<b class="mk-cmp-price">' + (p.price_varies ? 'From ' : '') + money(p.price) + '</b>' + (p.price === low ? ' <span class="mk-cmp-low">Lowest</span>' : ''); }) +
        row('Type', function (p) { return esc(p.type || '–'); }) +
        row('Highlights', function (p) { var b = bullets(p.description); return b.length ? '<ul>' + b.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '–'; }) +
        row('Features', function (p) { var t = niceTags(p.tags); return t.length ? t.map(function (x) { return '<span class="mk-cmp-tag">' + esc(x) + '</span>'; }).join(' ') : '–'; }) +
        row('Options', function (p) { return p.options && p.options.length ? esc(p.options.map(function (o) { return o.name + ' (' + (o.values || []).length + ')'; }).join(', ')) : '–'; }) +
        row('Stock', function (p) { return p.available ? 'In stock' : 'Sold out'; }) +
        row('', function (p) { return '<a class="mk-cmp-view" href="' + esc(p.url) + '">View product</a>'; }) +
        '</tbody></table><p class="mk-cmp-note">Details come from each product page. Check the product page for full specs before you buy.</p>';
      $('.mk-cmp-wrap', dlg).innerHTML = html;
    });
  }

  /* =====================================================================
     2. COMMAND SEARCH
     ===================================================================== */
  var pal, palInput, palList, palState = { items: [], active: -1, token: 0 };
  var TOOLS = [
    { t: 'Solar Winter Check', d: 'Will solar work at your place in December?', u: '/pages/solar-winter-check', k: 'solar winter december sun check map' },
    { t: 'Camera Cost Calculator', d: 'Subscription vs no monthly fees, year by year', u: '/pages/cost-calculator', k: 'cost calculator subscription monthly fee price compare ring' },
    { t: 'Coverage Planner', d: 'See what a camera covers, day and night', u: '/pages/coverage-planner', k: 'coverage night vision range angle field of view planner height' }
  ];
  var POPULAR = [
    ['Solar cameras', '/collections/solar-cameras'], ['4G cellular cameras', '/collections/4g-cellular-cameras'],
    ['Trail cameras', '/collections/trail-cameras'], ['Video doorbells', '/collections/video-doorbells'],
    ['Car theft protection', '/collections/car-theft-protection'], ['Solar power', '/collections/solar-power']
  ];

  function ensurePal() {
    if (pal) return;
    pal = h('div', 'mk-pal');
    pal.hidden = true;
    pal.innerHTML = '<div class="mk-pal-back" data-x></div><div class="mk-pal-box" role="dialog" aria-modal="true" aria-label="Search">' +
      '<div class="mk-pal-in"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>' +
      '<input type="search" inputmode="search" enterkeyhint="search" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="Try: solar camera under $150" aria-label="Search the store">' +
      '<button type="button" class="mk-pal-x" data-x aria-label="Close">Esc</button></div>' +
      '<div class="mk-pal-list" role="listbox"></div>' +
      '<div class="mk-pal-foot">Tip: add a price like <b>under $100</b> or <b>over $200</b>. Press Enter to search everything.</div></div>';
    D.body.appendChild(pal);
    palInput = $('input', pal); palList = $('.mk-pal-list', pal);
    pal.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) closePal(); });
    palInput.addEventListener('input', debounce(function () { runSearch(palInput.value); }, 180));
    palInput.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var it = palState.items[palState.active];
        if (it) location.href = it.u;
        else if (palInput.value.trim()) location.href = '/search?q=' + encodeURIComponent(palInput.value.trim());
      }
    });
  }
  function move(d) {
    var n = palState.items.length; if (!n) return;
    palState.active = (palState.active + d + n) % n;
    $$('.mk-pal-it', palList).forEach(function (e, i) { e.classList.toggle('is-act', i === palState.active); if (i === palState.active) e.scrollIntoView({ block: 'nearest' }); });
  }
  function openPal() {
    ensurePal(); pal.hidden = false; D.documentElement.classList.add('mk-pal-open');
    palInput.value = ''; runSearch('');
    setTimeout(function () { palInput.focus(); }, 30);
  }
  function closePal() { if (pal) { pal.hidden = true; D.documentElement.classList.remove('mk-pal-open'); } }

  function parseQ(q) {
    var max = null, min = null, t = ' ' + q + ' ';
    t = t.replace(/\$?\s*(\d+(?:\.\d+)?)\s*(?:-|to)\s*\$?\s*(\d+(?:\.\d+)?)/i, function (_, a, b) { min = +a; max = +b; if (min > max) { var x = min; min = max; max = x; } return ' '; });
    t = t.replace(/\b(?:under|below|less than|cheaper than|max|up to)\s*\$?\s*(\d+(?:\.\d+)?)|<\s*\$?\s*(\d+(?:\.\d+)?)/i, function (_, a, b) { max = +(a || b); return ' '; });
    t = t.replace(/\b(?:over|above|more than|min|at least)\s*\$?\s*(\d+(?:\.\d+)?)|>\s*\$?\s*(\d+(?:\.\d+)?)/i, function (_, a, b) { min = +(a || b); return ' '; });
    t = t.replace(/\b(cheap|cheapest|budget)\b/i, ' ').replace(/\s+/g, ' ').trim();
    return { text: t, max: max, min: min };
  }

  function itemHtml(it, i) {
    return '<a class="mk-pal-it" role="option" href="' + esc(it.u) + '" data-i="' + i + '">' +
      (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '<span class="mk-pal-ic">' + (it.ic || '→') + '</span>') +
      '<span class="mk-pal-tx"><b>' + esc(it.t) + '</b>' + (it.d ? '<small>' + esc(it.d) + '</small>' : '') + '</span>' +
      (it.p ? '<span class="mk-pal-pr">' + esc(it.p) + '</span>' : '') + '</a>';
  }
  function render(groups) {
    var items = [], html = '';
    groups.forEach(function (g) {
      if (!g.items.length) return;
      html += '<div class="mk-pal-h">' + esc(g.h) + '</div>';
      g.items.forEach(function (it) { html += itemHtml(it, items.length); items.push(it); });
    });
    if (!items.length) html = '<div class="mk-pal-empty">No matches yet. Press Enter to search the whole store.</div>';
    palList.innerHTML = html;
    palState.items = items; palState.active = items.length ? 0 : -1;
    var f = $('.mk-pal-it', palList); if (f) f.classList.add('is-act');
    $$('.mk-pal-it', palList).forEach(function (a) {
      a.addEventListener('mousemove', function () { palState.active = +a.dataset.i; $$('.mk-pal-it', palList).forEach(function (e, i) { e.classList.toggle('is-act', i === palState.active); }); });
    });
  }

  function runSearch(raw) {
    var q = parseQ(raw), tok = ++palState.token;
    var low = raw.toLowerCase();
    var tools = TOOLS.filter(function (t) { return !low.trim() ? true : (t.k + ' ' + t.t.toLowerCase()).split(' ').some(function (w) { return w.length > 2 && low.indexOf(w) > -1; }); })
      .map(function (t) { return { t: t.t, d: t.d, u: t.u, ic: '⚙' }; });
    if (!raw.trim()) {
      render([
        { h: 'Popular', items: POPULAR.map(function (p) { return { t: p[0], u: p[1], ic: '→' }; }) },
        { h: 'Free tools', items: tools }
      ]);
      return;
    }
    if (q.text.length < 2 && q.max == null && q.min == null) { render([{ h: 'Free tools', items: tools }]); return; }
    var term = q.text || 'camera';
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (tok !== palState.token) return;
        var res = (d.resources && d.resources.results) || {};
        var prods = (res.products || []).filter(function (p) {
          var pr = parseFloat(p.price);
          if (q.max != null && !(pr <= q.max)) return false;
          if (q.min != null && !(pr >= q.min)) return false;
          return true;
        });
        if (q.max != null || q.min != null) prods.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        var pitems = prods.map(function (p) {
          return { t: p.title, d: p.type || '', u: p.url.split('?')[0], img: p.image || (p.featured_image && p.featured_image.url) || '', p: '$' + parseFloat(p.price).toFixed(2) };
        });
        var label = 'Products';
        if (q.max != null && q.min != null) label += ' $' + q.min + '–$' + q.max;
        else if (q.max != null) label += ' under $' + q.max;
        else if (q.min != null) label += ' over $' + q.min;
        var cols = (res.collections || []).slice(0, 3).map(function (c) { return { t: c.title, d: 'Collection', u: c.url.split('?')[0], ic: '▦' }; });
        render([{ h: label, items: pitems }, { h: 'Collections', items: cols }, { h: 'Free tools', items: tools }]);
      }).catch(function () { if (tok === palState.token) render([{ h: 'Free tools', items: tools }]); });
  }

  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[aria-label="Search"].header-actions__action');
    if (b) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); openPal();
      setTimeout(function () { $$('dialog[open]').forEach(function (d) { if (/search-modal/.test(d.className)) d.close(); }); }, 0);
    }
  }, true);
  D.addEventListener('keydown', function (e) {
    var tag = (e.target && e.target.tagName) || '';
    var typing = /INPUT|TEXTAREA|SELECT/.test(tag) || (e.target && e.target.isContentEditable);
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openPal(); }
    else if (e.key === '/' && !typing && !e.metaKey && !e.ctrlKey) { e.preventDefault(); openPal(); }
    else if (e.key === 'Escape' && pal && !pal.hidden) closePal();
  });

  /* =====================================================================
     3. MOTION
     ===================================================================== */
  var io, cio;
  function motion() {
    if (reduce || !('IntersectionObserver' in window)) { countersNow(); return; }
    D.documentElement.classList.add('mk-motion');
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mk-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.4 });
    scan();
    setTimeout(function () { $$('.mk-rv').forEach(function (e) { e.classList.add('mk-in'); }); }, 4500);
    parallax();
  }
  function scan() {
    if (!io) return;
    $$('main product-card:not(.mk-rv)').forEach(function (c, i) {
      c.classList.add('mk-rv'); c.style.transitionDelay = Math.min((i % 4) * 70, 210) + 'ms'; io.observe(c);
    });
    $$('[data-mk-count]:not([data-mk-seen])').forEach(function (e) { e.setAttribute('data-mk-seen', '1'); cio.observe(e); });
  }
  function count(el) {
    var to = parseFloat(el.getAttribute('data-mk-count')) || 0, pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
    var t0 = null, dur = 1300;
    function step(ts) {
      if (t0 == null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), v = to * (1 - Math.pow(1 - p, 3));
      el.textContent = pre + Math.round(v).toLocaleString('en-CA') + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function countersNow() {
    $$('[data-mk-count]').forEach(function (el) {
      el.textContent = (el.getAttribute('data-prefix') || '') + Math.round(parseFloat(el.getAttribute('data-mk-count')) || 0).toLocaleString('en-CA') + (el.getAttribute('data-suffix') || '');
    });
  }
  function parallax() {
    var hero = $('.hero');
    if (!hero) return;
    var media = $('img, video', hero);
    if (!media) return;
    media.style.willChange = 'transform';
    var ticking = false;
    function upd() {
      ticking = false;
      var y = window.scrollY || 0, hh = hero.offsetHeight || 600;
      if (y > hh) return;
      media.style.transform = 'translate3d(0,' + (y * 0.14).toFixed(1) + 'px,0) scale(1.07)';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- boot ---------- */
  var queued = false;
  function a11y() {
    $$('a.hero__link').forEach(function (a) { if (!a.getAttribute('aria-label') && !a.textContent.trim()) a.setAttribute('aria-label', 'Shop security cameras'); });
    $$('main h1').forEach(function (e, i) { if (i > 0 && !e.getAttribute('role')) { e.setAttribute('role', 'heading'); e.setAttribute('aria-level', '2'); } });
  }
  function run() { queued = false; decorate(); scan(); a11y(); $$('button[aria-label="Search"].header-actions__action[on\\:click]').forEach(function (b) { b.removeAttribute('on:click'); }); }
  function boot() {
    run(); motion();
    new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(run); } }).observe(D.body, { childList: true, subtree: true });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();

  /* ---------- navigation layer (same asset folder; 10-minute cache key so edits reach visitors quickly) ---------- */
  try {
    var src = SELF && SELF.src;
    if (src) {
      var base = src.replace(/mk-site\.js.*$/, ''), q = '?v=' + Math.floor(Date.now() / 600000);
      ['mk-nav.css', 'mk-fixes.css'].forEach(function (f) { var l = D.createElement('link'); l.rel = 'stylesheet'; l.href = base + f + q; D.head.appendChild(l); });
      var sc = D.createElement('script'); sc.src = base + 'mk-nav.js' + q; sc.defer = true; D.head.appendChild(sc);
    }
  } catch (e) { }
})();
